module.exports = __webpack_public_path__ + "img/11.f630a148.png";